/* MADE IN quick add: a size/colour picker dialog for products with more than one variant.
   Opens from [data-mi-quick-add="handle"] buttons and from the "choose size" links on cards. */
(function () {
  'use strict';
  var cache = {};
  var dialog, lastOpener;

  function label(name) {
    var n = String(name || '');
    if (/colou?r|لون/i.test(n)) return 'اللون';
    if (/size|مقاس/i.test(n)) return 'المقاس';
    if (/style|type|نوع/i.test(n)) return 'النوع';
    return n;
  }
  function money(cents) { return (cents / 100).toFixed(2) + ' ر.س'; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var MI_COLOR_PHRASES = {
    'one color': 'لون واحد', 'single color': 'لون واحد', 'default': 'لون واحد', 'default title': 'لون واحد',
    'multicolor': 'متعدد الألوان', 'multi color': 'متعدد الألوان', 'multi-color': 'متعدد الألوان',
    'off white': 'أبيض مكسور', 'rose gold': 'ذهبي وردي', 'baby blue': 'أزرق سمائي',
    'baby pink': 'وردي فاتح', 'sky blue': 'أزرق سماوي', 'hot pink': 'وردي فاقع'
  };
  var MI_COLOR_WORDS = {
    black: 'أسود', white: 'أبيض', cream: 'كريمي', ivory: 'كريمي', beige: 'بيج', nude: 'بيج فاتح',
    brown: 'بني', tan: 'جملي', camel: 'جملي', rust: 'صدئي', grey: 'رمادي', gray: 'رمادي',
    charcoal: 'رمادي غامق', silver: 'فضي', gold: 'ذهبي', golden: 'ذهبي', red: 'أحمر',
    maroon: 'كستنائي', burgundy: 'عنابي', wine: 'نبيذي', pink: 'وردي', rose: 'وردي',
    coral: 'مرجاني', peach: 'خوخي', orange: 'برتقالي', yellow: 'أصفر', mustard: 'خردلي',
    green: 'أخضر', olive: 'زيتوني', khaki: 'كاكي', mint: 'نعناعي', sage: 'أخضر فاتح',
    emerald: 'زمردي', teal: 'تركوازي غامق', turquoise: 'تركوازي', blue: 'أزرق', navy: 'كحلي',
    denim: 'جينز', purple: 'بنفسجي', violet: 'بنفسجي فاتح', lavender: 'لافندر', lilac: 'ليلكي',
    plum: 'خوخي غامق', light: 'فاتح', dark: 'غامق', dusty: 'غامق', deep: 'داكن', pale: 'باهت',
    bright: 'فاقع', pastel: 'باستيل', color: '', colour: ''
  };
  function isColorOption(name) { return /colou?r|لون/i.test(String(name || '')); }
  function colorAr(val) {
    var raw = String(val || '').trim();
    var key = raw.toLowerCase();
    if (MI_COLOR_PHRASES[key]) return MI_COLOR_PHRASES[key];
    var words = raw.split(/\s+/).reverse();
    var out = words.map(function (w) {
      var wl = w.toLowerCase();
      return Object.prototype.hasOwnProperty.call(MI_COLOR_WORDS, wl) ? MI_COLOR_WORDS[wl] : w;
    }).filter(function (w) { return w !== ''; });
    return out.length ? out.join(' ') : raw;
  }

  function getProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('not found'); return r.json(); })
      .then(function (p) { cache[handle] = p; return p; });
  }

  function close() {
    if (!dialog) return;
    dialog.remove();
    dialog = null;
    document.documentElement.classList.remove('mi-qa-open');
    document.removeEventListener('keydown', onKey, true);
    if (lastOpener && lastOpener.focus) lastOpener.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab' || !dialog) return;
    var f = dialog.querySelectorAll('button:not([disabled]), a[href], input, [tabindex="0"]');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function build(p) {
    var options = p.options || [];
    var sel = options.map(function (o) { return (o.values && o.values.length === 1) ? o.values[0] : null; });
    var variants = p.variants || [];

    function match(picked) {
      return variants.filter(function (v) {
        return picked.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }
    function current() {
      if (sel.some(function (v) { return v === null; })) return null;
      return match(sel)[0] || null;
    }

    dialog = document.createElement('div');
    dialog.className = 'mi-qa';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', 'mi-qa-title');
    dialog.innerHTML =
      '<div class="mi-qa__backdrop" data-mi-qa-close></div>' +
      '<div class="mi-qa__panel" tabindex="-1">' +
        '<button type="button" class="mi-qa__x" data-mi-qa-close aria-label="إغلاق">&times;</button>' +
        '<div class="mi-qa__head">' +
          (p.featured_image ? '<img src="' + esc(p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=240') + '" alt="" width="72" height="90">' : '') +
          '<div><h2 id="mi-qa-title">' + esc(p.title) + '</h2><p class="mi-qa__price" data-mi-qa-price></p></div>' +
        '</div>' +
        '<div class="mi-qa__groups" data-mi-qa-groups></div>' +
        '<p class="mi-qa__msg" data-mi-qa-msg role="status" aria-live="polite"></p>' +
        '<form method="post" action="/cart/add" data-made-card-form>' +
          '<input type="hidden" name="id" value="" data-mi-qa-id><input type="hidden" name="quantity" value="1">' +
          '<button type="submit" name="add" class="mi-qa__add" data-mi-qa-add disabled>أضف للسلة</button>' +
        '</form>' +
        '<a class="mi-qa__more" href="' + esc(p.url) + '">عرض تفاصيل المنتج</a>' +
      '</div>';

    var groups = dialog.querySelector('[data-mi-qa-groups]');
    var priceEl = dialog.querySelector('[data-mi-qa-price]');
    var addBtn = dialog.querySelector('[data-mi-qa-add]');
    var idInput = dialog.querySelector('[data-mi-qa-id]');
    var msg = dialog.querySelector('[data-mi-qa-msg]');

    function render() {
      groups.innerHTML = options.map(function (o, gi) {
        var isColor = isColorOption(o.name);
        var pills = (o.values || []).map(function (val) {
          var probe = sel.slice(); probe[gi] = val;
          var ok = match(probe).some(function (v) { return v.available; });
          var on = sel[gi] === val;
          var text = isColor ? esc(colorAr(val)) : esc(val);
          return '<button type="button" class="mi-qa__pill' + (on ? ' is-on' : '') + (ok ? '' : ' is-out') + '" data-g="' + gi + '" data-v="' + esc(val) + '" aria-pressed="' + on + '"' + (ok ? '' : ' aria-disabled="true"') + '>' + text + '</button>';
        }).join('');
        return '<fieldset class="mi-qa__group"><legend>' + esc(label(o.name)) + '</legend><div class="mi-qa__pills">' + pills + '</div></fieldset>';
      }).join('');

      var v = current();
      var shown = v || variants.filter(function (x) { return x.available; })[0] || variants[0];
      var pr = v ? v.price : Math.min.apply(null, variants.map(function (x) { return x.price; }));
      var cmp = shown && shown.compare_at_price > pr ? shown.compare_at_price : 0;
      priceEl.innerHTML = '<strong>' + money(pr) + '</strong>' + (cmp ? ' <del>' + money(cmp) + '</del>' : '');
      if (v && v.available) { addBtn.disabled = false; idInput.value = v.id; msg.textContent = ''; addBtn.textContent = 'أضف للسلة'; }
      else if (v && !v.available) { addBtn.disabled = true; addBtn.textContent = 'غير متوفر'; msg.textContent = 'هذا الخيار غير متوفر حاليًا.'; }
      else {
        addBtn.disabled = true;
        var missing = options.filter(function (o, i) { return sel[i] === null; }).map(function (o) { return label(o.name); });
        addBtn.textContent = 'اختر ' + missing.join(' و');
        msg.textContent = '';
      }
    }

    dialog.addEventListener('click', function (e) {
      if (e.target.closest('[data-mi-qa-close]')) { close(); return; }
      var pill = e.target.closest('.mi-qa__pill');
      if (pill && pill.getAttribute('aria-disabled') !== 'true') {
        sel[+pill.getAttribute('data-g')] = pill.getAttribute('data-v');
        render();
        var again = groups.querySelector('.mi-qa__pill.is-on[data-g="' + pill.getAttribute('data-g') + '"]');
        if (again) again.focus();
      }
    });
    /* after a successful add the shared handler shows the cart toast; close the dialog */
    dialog.querySelector('form').addEventListener('submit', function () { setTimeout(close, 700); });
    render();
    return dialog;
  }

  function open(handle, opener) {
    lastOpener = opener;
    if (opener) opener.setAttribute('aria-busy', 'true');
    getProduct(handle).then(function (p) {
      if (opener) opener.removeAttribute('aria-busy');
      if (dialog) close();
      var d = build(p);
      document.body.appendChild(d);
      document.documentElement.classList.add('mi-qa-open');
      document.addEventListener('keydown', onKey, true);
      var panel = d.querySelector('.mi-qa__panel');
      (d.querySelector('.mi-qa__pill') || panel).focus();
    }).catch(function () {
      if (opener) { opener.removeAttribute('aria-busy'); if (opener.href) window.location.href = opener.href; }
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mi-quick-add]');
    if (btn) { e.preventDefault(); open(btn.getAttribute('data-mi-quick-add'), btn); return; }
    var link = e.target.closest && e.target.closest('a.made-options[href*="/products/"]');
    if (link && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (m) { e.preventDefault(); open(decodeURIComponent(m[1]), link); }
    }
  });
})();
